import useBreakpoint from '@/hooks/useBreakpoint';
import CheckoutContainerDesktop from './Designs/Desktop';
import CheckoutContainerMobile from './Designs/Mobile';

export type CheckoutContainerProps = {
  $valorTotal: number;
  $funcaoAdicionarAoCarrinho: () => void;
  $funcaoAcaoPrincial: () => void;
  $textoBotaoAcaoPrincipal: string;
  $permitirUsuarioRealizarCompra?: boolean;
};

export default function CheckoutContainer(props: CheckoutContainerProps) {
  const { breakpoint } = useBreakpoint();

  return breakpoint === 'mobile' ? (
    <CheckoutContainerMobile {...props} />
  ) : (
    <CheckoutContainerDesktop {...props} />
  );
}
